import type {
  createSpacingAliasesFn,
  createSpacingFn,
  createSpacingGlobalsFn,
} from "./types";

export const spacingGlobals = {
  xxxs: 2,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
  xxxl: 40,
  narrow: 10,
  wide: 18,
};

export const createSpacingAliases: createSpacingAliasesFn = (spacing) => {
  return {
    raisedSurfacePadding: spacing.md,
    cardGap: spacing.sm,
    cardPadding: spacing.xl,
  };
};

export const createSpacingGlobals: createSpacingGlobalsFn = () => {
  return spacingGlobals;
};

export const createSpacing: createSpacingFn = () => {
  const aliases = createSpacingAliases(spacingGlobals);

  return {
    ...spacingGlobals,
    ...aliases,
  };
};
